<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    景田站<br>
站点介绍<br>
景田站位于莲花西路与景田路的交叉路口的北侧，主要位于绿化带内。二号线车站沿莲花路布置，大致呈东西走向。九号线车站沿景田路布置，大致呈南北走向。车站周边住宅区分布较多，北侧有万科金色家园、景蜜村、景新花园、莲花北村、景洲大厦、布尾村等等，南侧有景田酒店 妇儿大厦 报业集团。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:19	23:59	2号线	2分35秒	5分45秒<br>
莲塘	06:02	23:40	2号线	2分35秒	5分45秒<br>
前湾	06:06	23:31	9号线	3分50秒	5分55秒<br>
文锦	06:28	23:38	9号线	3分50秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:24	23:59	2号线	4分钟	5分钟<br>
莲塘	06:02	23:40	2号线	4分钟	5分钟<br>
前湾	06:05	23:31	9号线	4分25秒	5分55秒<br>
文锦	06:28	23:38	9号线	4分25秒	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:24	00:49	2号线	4分钟	5分钟<br>
莲塘	06:02	00:40	2号线	4分钟	5分钟<br>
前湾	06:00	00:31	9号线	4分钟	5分55秒<br>
文锦	06:27	00:38	9号线	4分钟	5分55秒<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
碧景园、万托家园<br><br>
B出入口:<br>
深圳市司法局、福田图书馆<br><br>
C出入口:<br>
莲花路南侧、妇儿大厦、深圳商报社大厦、深圳市财政委员会（市财政委）<br><br>
D出入口:<br>
莲花路北侧（东）、景田东路、万科金色家园、北大医院、福田区中医院、福景外国语学校、福田劳动技术学校、景新花园<br><br>
E出入口:<br>
景秀小学、福田区文化馆、中国茶宫茗香苑<br><br>
F出入口:<br>
科技中学、深圳市交通监控中心、深圳华夏眼科医院<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 科技中学<br>
41、45、73、213、222、323、328、M391、M392、N6、高峰专线5、高快巴士（原E12）<br><br>
B出入口:<br>
公交站名： 妇儿大厦<br>
21、41、B613<br><br>
C出入口:<br>
公交站名： 景新花园①<br>
45、222、323、328、B613、M165、M391、M392、N6<br><br>
D出入口:<br>
公交站名： 景新花园②<br>
11、38、73、104、213<br><br>
E出入口:<br>
公交站名： 监控中心<br>
11、21、38、104<br><br>
F出入口:<br>
公交站名： 科技中学<br>
41、45、73、213、222、323、328、M391、M392、N6、、高快巴士（原E12）<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "erhaoxian",
          title: "2号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "jiuhaoxian",
          title: "9号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>